<div class="col-auto m-1">
  <ng-select
    class="w-100"
    bindValue="value"
    bindLabel="display"
    [placeholder]="label"
    [multiple]="multiple"
    (change)="onChange()"
    [items]="userTypes"
    [(ngModel)]="selectedUserTypes"
    dropdownPosition="bottom" />
</div>